module.exports = __webpack_public_path__ + "64f886b232962979e2eaf29d93108286.ttf";